// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nWLk","fullView":"styles_fullView__xZLVD"};